<template>
  <a-row>
    <a-menu
      v-model="currentMenu"
      mode="horizontal"
      style="font-size: 20px; margin-bottom: 25px"
    >
      <a-menu-item key="main_tab">
        <a-icon type="global" />
        {{ $t("Main") }}
      </a-menu-item>
      <!--<a-menu-item key="emailTemplates_tab">
        <a-icon type="mail" />
        {{ $t("Email templates") }}
      </a-menu-item>-->
      <a-menu-item key="matrix_tab">
        <a-icon type="solution" />
        {{ $t("Access matrix") }}
      </a-menu-item>
      <a-menu-item key="costCenter_tab">
        <a-icon type="audit" />
        {{ $t("Cost center/MPK") }}
      </a-menu-item>
      <a-menu-item key="nipSettings_tab">
        <a-icon type="file-done" />
        {{ $t("Saving company data") }}
      </a-menu-item>
    </a-menu>
    <a-form
      v-show="currentMenu.includes('main_tab')"
      id="settings_main_form"
      :form="form_main"
      @submit="handleSubmit_main"
      :label-col="{
        xs: { span: 24 },
        sm: { span: 8 },
      }"
      labelAlign="left"
      :wrapper-col="{
        xs: { span: 24 },
        sm: { span: 12 },
      }"
    >
      <a-form-item
        :label='$t("License key")'
        has-feedback
        :validate-status="licenseKey.validateStatus"
        :help="licenseKey.tips"
      >
        <a-input
          v-decorator="[
            'licenseKey',
            {
              rules: [{ required: false }],
              initialValue: settings.license.lic_key,
            },
          ]"
        />
        <!-- user_val.licenseKey -->
      </a-form-item>
      <a-form-item
        :label="$t('Document folder')"
        :help="$t('Select a storage location')"
      >
        <a-select
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'folder',
            { rules: [{ required: false }], initialValue: user_val.folder },
          ]"
        >
          <a-select-option
            v-for="folder in folders"
            :key="folder.NAME"
            :value="folder.ID"
            >{{ folder.NAME }}</a-select-option
          >
        </a-select>
      </a-form-item>

      <a-form-item
        :label="$t('Responsible for registration')"
        :help="
          $t('Select the person responsible for registration from the list')
        "
      >
        <a-select
          mode="multiple"
          optionFilterProp="children"
          :dropdownMatchSelectWidth="false"
          v-decorator="[
            'responsible',
            {
              rules: [{ required: false }],
              initialValue: user_val.responsible,
            },
          ]"
        >
          <a-select-option v-for="(name, id) in usernameList" :key="id">{{
            name
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('Mail folder')">
        <a-select
          showSearch
          allowClear
          optionFilterProp="children"
          v-decorator="[
            'mail_folder',
            {
              rules: [{ required: false }],
              initialValue: user_val.mail_folder,
            },
          ]"
        >
          <a-select-option
            v-for="folder in folders"
            :key="folder.NAME"
            :value="folder.ID"
            >{{ folder.NAME }}</a-select-option
          >
        </a-select>
      </a-form-item>

      <a-form-item
        :label="$t('Mail responsible')"
        :help="$t('Select the person responsible for acceptance from the list')"
      >
        <a-select
          allowClear
          optionFilterProp="children"
          :dropdownMatchSelectWidth="false"
          v-decorator="[
            'mail_user',
            {
              rules: [{ required: false }],
              initialValue: user_val.mail_user,
            },
          ]"
        >
          <a-select-option v-for="(name, id) in usernameList" :key="id">{{
            name
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-divider>
        {{ $t("Spolka") }}
      </a-divider>
      <a-form-item :label="$t('Bank account')">
        <a-select
          :dropdownMatchSelectWidth="false"
          v-decorator="[
            'BankAccount',
            {
              rules: [{ required: false }],
              initialValue: user_val.BankAccount,
            },
          ]"
        >
          <a-select-option
            v-for="key in userfields"
            :value="key['title']"
            :key="key['title']"
            >{{ key["listLabel"] || key['title']}}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('Company type')" :help="$t('Select type')">
        <a-select
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'companyType',
            {
              rules: [{ required: false }],
              initialValue: user_val.companyType,
            },
          ]"
        >
          <a-select-option
            v-for="comp in settings['crm_status_list']"
            :value="comp.ID"
            :key="comp.NAME"
            >{{ comp.NAME }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('Termin Płatności')" :help="$t('Select type')">
        <a-select
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'terminPlat',
            {
              rules: [{ required: false }],
              initialValue: user_val.termin,
            },
          ]"
        >
          <a-select-option
            v-for="key in userfields"
            :value="key['title']"
            :key="key['title']"
            >{{ key["listLabel"] || key['title']}}</a-select-option
          >
        </a-select>
      </a-form-item>

      <a-divider>
        {{ $t("Księgowość") }}
      </a-divider>

      <a-form-item :label="$t('Biuro Księgowe')">
        <a-select
          mode="multiple"
          optionFilterProp="children"
          :dropdownMatchSelectWidth="false"
          v-decorator="[
            'bookkeeping',
            {
              rules: [{ required: false }],
              initialValue: user_val.bookkeeping,
            },
          ]"
        >
          <a-select-option v-for="(name, id) in usernameList" :key="id">{{
            name
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        :label="$t('Responsible for export')"
        :help="$t('Select the person responsible for export')"
      >
        <a-select
          mode="multiple"
          optionFilterProp="children"
          :dropdownMatchSelectWidth="false"
          v-decorator="[
            'responsibleExport',
            {
              rules: [{ required: false }],
              initialValue: user_val.responsibleExport,
            },
          ]"
        >
          <a-select-option v-for="(name, id) in usernameList" :key="id">{{
            name
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <!--
      <a-divider>
        {{ $t("Budżety") }}
      </a-divider>
      
      <a-form-item :label="$t('Specjalista CS')">
        <a-select
          showSearch
          optionFilterProp="children"
          mode="multiple"
          style="width: 100%"
          placeholder="Please select"
          v-decorator="[
            'mediaAssigned',
            {
              rules: [{ required: false }],
              initialValue: user_val.mediaAssigned,
            },
          ]"
        >
          <a-select-option
            v-for="(name, id) in usernameList"
            :key="id"
          >{{
            name
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('Odpowiedzialny za budżety')">
        <a-select
          showSearch
          optionFilterProp="children"
          mode="multiple"
          style="width: 100%"
          placeholder="Please select"
          v-decorator="[
            'mediaResponsible',
            {
              rules: [{ required: false }],
              initialValue: user_val.mediaResponsible,
            },
          ]"
        >
          <a-select-option v-for="(name, id) in usernameList" :key="id">{{
            name
          }}</a-select-option>
        </a-select>
      </a-form-item>-->

      <a-divider>
        {{ $t("Numerators") }}
      </a-divider>

      <a-form-item :label='$t("Zmiana Numeru")' :help="invoiceExample">
        <a-select
          showSearch
          optionFilterProp="children"
          style="width: 100%"
          @change="changeNumberInvoice"
          mode="tags"
          v-decorator="[
            'numberInvoice',
            {
              rules: [{ required: false }],
              initialValue: user_val.numberInvoice,
            },
          ]"
        >
          <a-select-option key="invoiceType">{{ $t('Type') }}</a-select-option>
          <a-select-option key="companyName">{{ $t('Company name') }}</a-select-option>
          <a-select-option key="number">{{ $t('Number') }}</a-select-option>
          <a-select-option key="month">{{ $t('Month') }}</a-select-option>
          <a-select-option key="year">{{ $t('Year') }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('Company field')">
        <a-select
          showSearch
          optionFilterProp="children"
          style="width: 100%"
          v-model="numerator.field"
        >
          <a-select-option v-for="(name, id) in FIELDS_LIST" :key="id">{{
            name
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('Company')" v-if="numerator.field">
        <a-select
          showSearch
          optionFilterProp="children"
          style="width: 100%"
          v-model="numerator.company"
          @change="() => numerator.key++"
        >
          <a-select-option v-for="(item, id) in COMPANY_LIST" :key="id">{{
            item.TITLE
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('Numerator')" v-if="numerator.company">
        <a-input-search
          :key="numerator.key"
          :defaultValue="COMPANY_LIST[numerator.company][numerator.field]"
          @search="onSaveNumerator"
        >
          <a-button
            type="primary"
            slot="enterButton"
            :loading="numerator.loading"
          >
            {{ $t("Save") }}
          </a-button>
        </a-input-search>
      </a-form-item>

      <a-form-item :label='$t("Typ Numeru")'>
        <a-select
          showSearch
          optionFilterProp="children"
          style="width: 100%"
          v-model="typeNumerator.type"
          @change="() => typeNumerator.key++"
        >
          <a-select-option key="Faktura Kosztowa"
            >{{ $t('Faktura Kosztowa') }}</a-select-option
          >
          <a-select-option key="Proforma">{{ $t('Proforma') }}</a-select-option>
          <a-select-option key="VAT Marza">{{ $t('Faktura do Proformy') }}</a-select-option>
          <a-select-option key="Korygujaca">{{ $t('Korygująca') }}</a-select-option>
          <a-select-option key="Faktura zaliczkowa"
            >{{ $t('Faktura zaliczkowa') }}</a-select-option
          >
          <a-select-option key="Faktura koncowa"
            >{{ $t('Faktura końcowa') }}</a-select-option
          >
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('Numerator')" v-if="typeNumerator.type">
        <a-input-search
          :key="typeNumerator.key"
          :defaultValue="user_val.typeInvoice[typeNumerator.type]"
          @search="onSaveTypeNumerator"
        >
          <a-button
            type="primary"
            slot="enterButton"
            :loading="typeNumerator.loading"
          >
            {{ $t("Save") }}
          </a-button>
        </a-input-search>
      </a-form-item>

      <a-divider>
        {{ $t("Other") }}
      </a-divider>

      <a-form-item :label='$t("Company szablonów")'>
        <a-select
          showSearch
          optionFilterProp="children"
          @change="handlerCompanyType"
          v-decorator="[
            'companyTemplate',
            {
              rules: [{ required: false }],
              //initialValue: user_val.mediaResponsible,
            },
          ]"
        >
          <a-select-option v-for="(item, id) in COMPANY_LIST" :key="id">{{
            item.TITLE
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label='$t("Ustawienie szablonów")'>
        <a-select
          showSearch
          optionFilterProp="children"
          style="width: 48%"
          @change="handlerInvoiceType"
          v-decorator="[
            'forTemplateType',
            {
              rules: [{ required: false }],
              //initialValue: user_val.mediaResponsible,
            },
          ]"
        >
          <a-select-option key="Faktura Kosztowa"
            >{{ $t('Faktura Kosztowa') }}</a-select-option
          >
          <a-select-option key="Proforma">{{ $t('Proforma') }}</a-select-option>
          <a-select-option key="VAT Marza">{{ $t('Faktura do Proformy') }}</a-select-option>
          <a-select-option key="Korygujaca">{{ $t('Korygująca') }}</a-select-option>
          <a-select-option key="Faktura zaliczkowa"
            >{{ $t('Faktura zaliczkowa') }}</a-select-option
          >
          <a-select-option key="Faktura koncowa"
            >{{ $t('Faktura końcowa') }}</a-select-option
          >
        </a-select>
        <a-select
          showSearch
          optionFilterProp="children"
          style="width: 49%; margin-left: 10px"
          v-decorator="[
            'templateID',
            {
              rules: [{ required: false }],
              initialValue: idTemplate,
            },
          ]"
        >
          <a-select-option v-for="item in templates" :key="item.id">{{
            item.name
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('api_ocr_token')">
        <a-input
          v-decorator="[
            'api_ocr_token',
            {
              rules: [{ required: true, message: $t('api_ocr_token_missing') }],
              initialValue: user_val.api_ocr_token,
            },
          ]"
        />
      </a-form-item>

      <a-form-item
        align="center"
        :label-col="{ span: 0 }"
        :wrapper-col="{ span: 24 }"
      >
        <a-button type="primary" html-type="submit" size="large">{{
          $t("Save")
        }}</a-button>
      </a-form-item>
    </a-form>
    <!--<emailTemplates
      :usernameList="usernameList"
      v-show="currentMenu.includes('emailTemplates_tab')"
    />-->
    <SaveCompanyData v-if="currentMenu.includes('nipSettings_tab')" />
    <AccessMatrix
      v-show="currentMenu.includes('matrix_tab')"
      :myCompany="this.settings.my_company"
      :costCenter="settings.costCenter"
      :usernameList="usernameList"
      :accessMatrix="settings.matrix"
      :responsibleFVS="{
        responsibleRead: this.user_val.responsibleRead,
        responsibleSpredz: this.user_val.responsibleSpredz,
        responsibleAll: this.user_val.responsibleAll,
        responsibleOffice: this.user_val.responsibleOffice,
      }"
      :defaultResponsible="settings.defaultResponsible"
      :rightsToInvoiceFunnel="settings.rightsToInvoiceFunnel"
    />
    <CostCenter
      v-show="currentMenu.includes('costCenter_tab')"
      :costCenter="settings['costCenter']"
      :mainMPK="settings.my_company"
      :CostTypesList="user_val.CostTypes"
      :usernameList="usernameList"
      :user_val="user_val"
      :MPKList="user_val.MPK"
    />
  </a-row>
</template>
<script>
// import { saveSettings, checkLicense, getDataSettings } from "@/requestFunc";
import { saveSettings,  getDataSettings } from "@/requestFunc";
import CostCenter from "./settingsCostCenter.vue";
import AccessMatrix from "./settingsAccessMatrix.vue";
import SaveCompanyData from "@/components/integrationNip/SaveCompanyData";
//import emailTemplates from "@/components/settingsEmailTemplates";
import moment from "moment";

export default {
  props: ["settings", "user_val", "COMPANY_LIST"],
  components: { AccessMatrix, CostCenter, SaveCompanyData },
  data() {
    return {
      idTemplate: "",
      folders: [],
      //: [],
      companyIdTempl: "",
      templates: [],
      userfields: [],
      domain: null,
      licenseKey: {
        tips: "",
        validateStatus: "error",
      },
      form_main: this.$form.createForm(this, { name: "set_main" }),
      form_matrix: this.$form.createForm(this, { name: "set_matrix" }),
      form_invoices: this.$form.createForm(this, { name: "set_invoices" }),
      currentMenu: ["main_tab"],
      usernameList: {},

      invoiceExample: "",
      exampleValues: {
        invoiceType: "FV",
        companyName: "PT",
        number: "01",
        month: "11",
        year: "2020",
      },
      numerator: {
        company: "",
        field: "",
        key: 0,
        loading: false,
      },
      typeNumerator: {
        type: "",
        field: "",
        key: 0,
        loading: false,
      },
      FIELDS_LIST: {},
    };
  },
  methods: {
    moment,
    changeNumberInvoice(e) {
      this.invoiceExample = "";
      for (let i in e) {
        this.invoiceExample += this.exampleValues[e[i]];

        if (
          ["number", "month", "year"].includes(e[i]) &&
          ["number", "month", "year"].includes(e[1 + i * 1])
        ) {
          this.invoiceExample += "/";
        }
      }
    },
    onSaveTypeNumerator(val) {
      this.numerator.loading = true;
      this.openNotificationWithIcon("success");
      this.user_val.typeInvoice[this.typeNumerator.type] = val;
      BX24.appOption.set("typeInvoice", this.user_val.typeInvoice);
      this.numerator.loading = false;
    },
    getCompanyFields() {
      BX24.callMethod("crm.company.fields", {}, (result) => {
        var fieldsList = result.data();
        let list = {};
        for (let field in fieldsList) {
          if (
            fieldsList[field].listLabel &&
            fieldsList[field]["type"] == "string"
          ) {
            list[field] = fieldsList[field]["listLabel"];
          }
        }
        this.FIELDS_LIST = Object.assign({}, this.FIELDS_LIST, list);

      });
    },
    onSaveNumerator(val) {
      this.numerator.loading = true;

      const { company, field } = this.numerator;
      BX24.callMethod(
        "crm.company.update",
        {
          id: company,
          fields: {
            [field]: val,
          },
          params: { REGISTER_SONET_EVENT: "Y" },
        },
        (result) => {
          if (result.error()) this.openNotificationWithIcon("error");
          else {
            console.info(result.data());
            this.COMPANY_LIST[company][field] = val;
            this.openNotificationWithIcon("success");
          }
          this.numerator.loading = false;
        }
      );
    },
    openNotificationWithIcon(type) {
     // window.parent.scroll(0, 0);
      this.$notification[type]({
        message:
          type == "success"
            ? this.$t("savenumerator")
            : this.$t("errorsavenumerator"),
      });
    },
    async validateLicenseKey(key) {
      if (!key) {
        this.licenseKey.tips = "";
        this.licenseKey.validateStatus = "error";
      } else {
        this.licenseKey.validateStatus = "validating";
        // let response = await checkLicense(key);

          try {
            this.licenseKey.tips = `${this.$t("Until the end of the license")} ${moment(
                      this.settings.license.lic_end_date,
                      "YYYY-MM-DD"
                    ).diff(moment(), "days")} ${this.$t("days")}`; 

            if (!this.settings?.license?.lic_key) {
              if (moment().isBefore(this.settings.license.trial_end_date)) {
                // this.licenseKey.tips = `${this.$t("Until the end of the license")} ${moment(
                //   this.settings.license.trial_end_date,
                //   "YYYY-MM-DD"
                // ).diff(moment(), "days")} ${this.$t("days")}`; 

                this.licenseKey.validateStatus = "success";
              } else { 
                // this.licenseKey.tips = "";
                this.licenseKey.validateStatus = "error";
              }
                
            } else {
              if (moment().isBefore(this.settings.license.lic_end_date)) {
                //  this.licenseKey.tips = `${this.$t("Until the end of the license")} ${moment(
                //   this.settings.license.lic_end_date,
                //   "YYYY-MM-DD"
                // ).diff(moment(), "days")} ${this.$t("days")}`; 

                this.licenseKey.validateStatus = "success";
              } else { 
                // this.licenseKey.tips = "";
                this.licenseKey.validateStatus = "error";
              }
            }
            
          } catch (e) {
            this.licenseKey.tips = "";
            this.licenseKey.validateStatus = "error";
          }
        
      }
    },
    changeSpinning(val) {
      this.$emit("changeSpinning", val);
    },
    handlerCompanyType(e) {
      this.companyIdTempl = e;
      this.handlerInvoiceType('Faktura');
    //  this.idTemplate = "";
    },
    handlerInvoiceType(e) {
      if (this.companyIdTempl && e && this.companyIdTempl in this.user_val.templateSettings) {
        this.idTemplate = this.user_val.templateSettings[this.companyIdTempl][
          e
        ];
      }
    },
    handleSubmit_main(e) {
      e.preventDefault();
      this.form_main.validateFields((err, values) => {
        if (!err) {
          this.changeSpinning();
          values["numeratorField"] = this.numerator.field;
          values['mail_folder'] = values['mail_folder'] ? values['mail_folder'] : '';
          values['mail_user'] = values['mail_user'] ? values['mail_user'] : '';
          this.validateLicenseKey(values.licenseKey);
          saveSettings(values)
            .done((res) => {
              let vals = JSON.parse(res);
              this.$message.success(this.$t("Settings have been saved!"));
              this.$emit("updateFiles", {
                files: vals.all_file,
                settings: { ...values },
              });
            })
            .fail((e) => {
              console.error(e);
              this.$message.error(this.$t("Error"));
            })
            .always(() => {
              this.changeSpinning();
            });
        }
      });
    },
    getData() {
      this.changeSpinning();
      getDataSettings()
        .done((res) => {
          let result = JSON.parse(res);
          this.folders = result.data_getchildren;
          this.userfields = result.userfields;
          //this.COMPANY_LIST = result.myCompany;
          let kk = {};
          for (let i of result.data_user) {
            kk[i.ID] = `${i.NAME} ${i.LAST_NAME}`;
          }
          this.usernameList = Object.assign({}, this.usernameList, kk);
          //this.settings['data_getchildren'] = result.data_getchildren;
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error"));
        })
        .always(() => {
          this.changeSpinning(false);
        });
      
    },
    resize() {
      BX24.resizeWindow(
        parseInt($("body #root_block").css("width")),
        parseInt($("body #root_block").css("height"))
      );
    },
  },
  async mounted() {
    this.getData();
    BX24.callMethod("crm.documentgenerator.template.list", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        // console.log(result.data());
        if (result.more()) {
          result.next();
        } else {
          this.templates = result.data().templates;
        }
      }
    });
    // console.log("mounted: ",{"this.user_val":this.user_val, settings:this.settings})
  
    // await this.validateLicenseKey(this.user_val.licenseKey);
    await this.validateLicenseKey(this.settings?.license?.lic_key);
    this.changeSpinning(false);
    this.getCompanyFields();
    this.changeNumberInvoice(this.user_val.numberInvoice);
    this.numerator.field = this.settings.numeratorField;
    let auth = BX24.getAuth();
    this.domain = " https://" + auth.domain + "/crm/company/details/";

    this.resize();
  },
  updated() {
    this.resize();
  },
};
</script>

<style scoped>
.settingsApp {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.settingsApp h2 {
  font-size: 24px;
}

.matrix__elem {
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 10px 10px 20px #c9c9c9, 0px 0px 0px #ffffff;
}

.matrix__elem .title {
  padding: 10px 0;
  font-size: 16px;
}

.matrix__elem .hubLeader {
  text-align: left;
  padding: 10px 15px 0 15px;
  border-top: 1px solid lightskyblue;
}

.matrix__elem .projAsistant {
  text-align: left;
  padding: 10px 15px 0 15px;
}

.matrix__elem .Poufny {
  text-align: left;
  padding: 0 15px;
}

#settings_main_form .ant-form-item-control-wrapper {
  text-align: left;
}
</style>
